import { Controller } from "stimulus"

// Drives the drill-down modal for the "Résultats globaux" cards: clicking a
// card's eye icon opens a shared modal filled with that card's breakdown by
// exam type (field_category) and candidate type. Data travels in data-* attrs
// so no request is needed — everything is already in the snapshot on the page.
export default class extends Controller {
  static targets = ["modal", "title", "total", "categoryBody", "typeBody"]

  static CATEGORY_LABELS = { general: "Générale", technical: "Technique", professional: "Professionnel" }
  static TYPE_LABELS = { public: "Public", private: "Privé", free: "Candidat libre", foreign: "Étranger" }

  connect() {
    // Delegated toggle for expanding a category into its fields
    this._onCatClick = (e) => {
      const btn = e.target.closest(".et-toggle")
      if (btn) this.toggleCat(btn)
    }
    this.categoryBodyTarget.addEventListener("click", this._onCatClick)
  }

  disconnect() {
    if (this._onCatClick) this.categoryBodyTarget.removeEventListener("click", this._onCatClick)
  }

  open(e) {
    const trigger = e.currentTarget
    const data = JSON.parse(trigger.dataset.payload)
    // suffix "%" → values are rates (1 decimal); otherwise raw counts
    const suffix = trigger.dataset.suffix || ""

    this.titleTarget.textContent = trigger.dataset.label
    this.totalTarget.textContent = trigger.dataset.totalText || this.formatVal(trigger.dataset.total, suffix)

    this.categoryBodyTarget.innerHTML = this.categoryColumn(data.category, data.categoryFields, suffix)
    this.typeBodyTarget.innerHTML = this.rows(this.constructor.TYPE_LABELS, data.candidate_type, suffix)

    this.modalTarget.classList.add("is-open")
    this.lockScroll(true)
  }

  // Lock page scroll while the modal is open. The scroll container can be
  // <html> or <body> depending on the layout, so lock both.
  lockScroll(locked) {
    const value = locked ? "hidden" : ""
    document.documentElement.style.overflow = value
    document.body.style.overflow = value
  }

  toggleCat(btn) {
    const cat = btn.dataset.cat
    const expanded = btn.classList.toggle("is-expanded")
    btn.textContent = expanded ? "−" : "+"
    this.categoryBodyTarget
      .querySelectorAll(`tr[data-parent="${cat}"]`)
      .forEach((row) => row.classList.toggle("is-hidden", !expanded))
  }

  close(e) {
    if (e) e.preventDefault()
    this.modalTarget.classList.remove("is-open")
    this.lockScroll(false)
  }

  // Close only when the backdrop itself (not the dialog) is clicked
  backdrop(e) {
    if (e.target === this.modalTarget) this.close(e)
  }

  rows(labels, values = {}, suffix = "") {
    return Object.entries(labels)
      .map(([key, label]) => `<tr><td>${label}</td><td>${this.formatVal(values[key], suffix)}</td></tr>`)
      .join("")
  }

  // Category column with each category expandable into its fields (by sigle)
  categoryColumn(totals = {}, categoryFields = {}, suffix = "") {
    return Object.entries(this.constructor.CATEGORY_LABELS)
      .map(([key, label]) => {
        const fields = (categoryFields && categoryFields[key]) || []
        const toggle = fields.length
          ? `<button type="button" class="et-toggle" data-cat="${key}">+</button>`
          : `<span class="et-toggle-spacer"></span>`
        let html = `<tr class="et-cat"><td>${toggle}${label}</td><td>${this.formatVal(totals[key], suffix)}</td></tr>`
        html += fields
          .map((f) => `<tr class="et-field is-hidden" data-parent="${key}"><td>${f.sigle}</td><td>${this.formatVal(f.value, suffix)}</td></tr>`)
          .join("")
        return html
      })
      .join("")
  }

  formatVal(v, suffix = "") {
    const n = Number(v) || 0
    if (suffix === "%") {
      return `${n.toLocaleString("fr-FR", { maximumFractionDigits: 1 })} %`
    }
    return this.fmt(v)
  }

  fmt(n) {
    return (Number(n) || 0).toLocaleString("fr-FR")
  }
}
